//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useFormContext } from 'react-hook-form';

import { CampaignRequest } from '@apis/campaign-requests/shared/CampaignRequests';
import { CAMPAIGN_REQUEST_FORM_VALIDATION } from '@campaigns/constants/CampaignRequestFormValidationConstants';
import { CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/CampaignsTrackingId';
import { FormFieldController } from '@components/form/field-controller/FormFieldController';
import { FormTextInput } from '@components/form/text-input/FormTextInput';

interface CampaignRequestNameFieldProps {
  isDisabled?: boolean;
}

export const CampaignRequestNameField = ({
  isDisabled,
}: CampaignRequestNameFieldProps) => {
  const { control } = useFormContext<CampaignRequest>();

  return (
    <div>
      <FormFieldController
        control={control}
        name='name'
        rules={CAMPAIGN_REQUEST_FORM_VALIDATION.name}
      >
        {(props) => (
          <>
            <FormTextInput
              {...props}
              isDisabled={!!isDisabled}
              label='Name'
              placeholder='Enter campaign name'
              trackingId={CAMPAIGNS_TRACKING_ID.CREATE_CAMPAIGN_NAME_INPUT}
            />
          </>
        )}
      </FormFieldController>
    </div>
  );
};
